import { IgAccount, IgMedia, IgMediaTime } from '@core/models/ApiFields/ig-entities';
import { TimeFields } from '@core/models/ApiFields/time-fields.enums';
import { Dimension } from '@features/social-analysis/models/IDimensions';
import { getDefaultColsObj } from '@features/social-analysis/utils/table-utils';
import { deepcopy } from '@shared/utils/Objects';
import { accountMetrics, insightsDims, insightsMetrics, mediaMetrics } from './insights';
import { COMPONENTS_ENUM } from './page';

const sentimentCols: Dimension[] = [
    {
        display: 'Captions sentiment',
        value: IgMedia.getPrefixed('captionsPositivity'),
        prefix: IgMedia.prefix,
    },
    {
        display: 'Comments sentiment',
        value: IgMediaTime.getPrefixed('commentsPositivity'),
        prefix: IgMediaTime.prefix,
    },
];

const getCols = () => {
    const mediaMetricsCopy = deepcopy(mediaMetrics);
    mediaMetricsCopy.values.unshift(...sentimentCols);
    return [mediaMetricsCopy, accountMetrics];
};

const initColumns: Record<string, true> = getDefaultColsObj(insightsMetrics);

const initDim = TimeFields.date;

export const fixedDim = IgAccount.getPrefixed('igAccount');

const getInitDimension = () => [
    insightsDims.flatMap(categ => categ.values).find(opt => opt.value === fixedDim) as Dimension,
    insightsDims.flatMap(categ => categ.values).find(opt => opt.value === initDim) as Dimension,
];

const getInitSort = () => [
    { prop: fixedDim, dir: 'asc' },
    { prop: initDim, dir: 'desc' },
];

export const insightsTableInit = {
    component: COMPONENTS_ENUM.TABLE,
    columns: getCols(),
    selectedCols: initColumns,
    dimOpts: insightsDims,
    dimensions: getInitDimension(),
    sorting: getInitSort(),
};
